<template>
  <div class="investment_warp">
    <div class="content">
      <!-- 表单 -->
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
        <a-row>
          <a-form-model-item label="订单超过:" prop="time">
            <a-input type="number" style="width: 100px"  v-model="searchList.time"
            :allowClear="true" placeholder="请输入" /> 分钟未付款，订单自动关闭
          </a-form-model-item>
        </a-row>
        <!-- <a-row>
          <a-form-model-item label="开启自动发货:" prop="reson">
            <a-radio-group v-model="searchList.type">
              <a-radio :value="1">
                开启，无需发货商品，自动发货
              </a-radio>
              <a-radio :value="2">
                停用，需人工确认再发货
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-row> -->
      </a-form-model>

      <!-- 按钮 -->
      <div class="content_but">
        <a-button type="primary" @click="handle_submit">提交</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  setTimeOut
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  name: "",
  components: {
  },
  data() {
    //自定义校验规则
    var checkTime = (rule, value, callback) => {
      if (value) {
        if (value <= 0) {
          return callback(new Error('请输入大于0的数'));
        } else if (!Number.isInteger(Number(value))) {
          return callback(new Error('请输入整数'));
        } else if (Number(value) > 9999) {
          return callback(new Error('订单时间不能超过4位数'));
        }
      }
      return callback();
    };
    return {
      //固定宽度
      labelCol: { span: 3 },
      wrapperCol: { span: 10 },

      //绑定值
      searchList: {
        time:"",
      },

      //校验规则
      rules: {
        time: [
          {
            required: true,
            message: "请输入订单超时时间",
            trigger: "blur",
          },
          {
            validator: checkTime,
            trigger: "change",
          },
        ],
      },
      
    };
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["TIME_OUT"]).then((res) => {
      //时间
      this.searchList.time = DictionaryService.getOptions("TIME_OUT")[0].value;
    });
  },
  methods: {
    // 提交
    handle_submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          setTimeOut({
            time:this.searchList.time,
          }).then(
            (res) => {
              if (res.code == '0000') {
                this.$message.success('操作成功！');
              }
            },
            (err) => {
              this.$message.warning('请输入过期时间为1-10000分钟！');
            }
          );
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.content{
  padding: 30px 8px 8px 8px;
}

.content_but{
  margin-left: 90px;
}

.select_width {
  width: 180px !important;
}
.ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.investment_flex {
  display: flex;
  margin-bottom: 15px;
}
.investment_li {
  margin-right: 15px;
}
.custom {
  margin: 5px;
  color: #4093e1;
  cursor: pointer;
}
.table_pagination {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.box_warp {
  overflow-y: auto;
}
.end {
  justify-content: flex-end;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 10px 0px;
  margin-bottom: 20px;
  padding: 0 5px;
  border-left: 5px solid #0b2464;
}

.table_bottom{

  .bottom_btn{
    margin-top: 10px;

    .btn_first{
      margin-right: 10px;
    }
  }



}
</style>